export const renderSkeleton = () => {
	let htmlItems = '';

	for (let index = 0; index < 9; index++) {
		htmlItems += renderSkeletonItem();
	}

	return htmlItems;
};

const renderSkeletonItem = () => {
	let html = `
        <div class="wikpis-filter-taxonomy__item--skeleton">
            <div class="skeleton__image">    
            </div>
            <div class="skeleton__text">
                <h3 class="skeleton__title"></h3>
                <div class="skeleton__paragraph">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="skeleton__date"></div>
            </div>
        </div>  
    `;

	return html;
};
